import { useTranslation } from "react-i18next";
import { Card, CardHeader } from "../ui/Card";
import { useOrg } from "../auth/OrgProvider";

export function DashboardPage() {
  const { t } = useTranslation("dashboard");
  const { activeOrg } = useOrg();
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          {activeOrg ? t("welcome", { org: activeOrg.name }) : t("welcomeGeneric")}
        </h1>
        <p className="text-sm text-slate-500">{t("subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard
          label={t("stats.activeCustomers")}
          value={t("stats.placeholder")}
          hint={t("hints.stage1")}
        />
        <StatCard
          label={t("stats.openInvoices")}
          value={t("stats.placeholder")}
          hint={t("hints.stripeLater")}
        />
        <StatCard
          label={t("stats.quotesThisMonth")}
          value={t("stats.placeholder")}
          hint={t("hints.satelliteLater")}
        />
      </div>
      <Card>
        <CardHeader title={t("whatsNext.title")} description={t("whatsNext.description")} />
        <ol className="ml-5 list-decimal space-y-1 text-sm text-slate-700">
          <li>{t("whatsNext.items.stage2")}</li>
          <li>{t("whatsNext.items.stage3")}</li>
          <li>{t("whatsNext.items.stage4")}</li>
          <li>{t("whatsNext.items.stage5")}</li>
        </ol>
      </Card>
    </div>
  );
}

function StatCard({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <Card>
      <p className="text-sm font-medium text-slate-500">{label}</p>
      <p className="mt-2 text-3xl font-semibold text-slate-900">{value}</p>
      {hint ? <p className="mt-1 text-xs text-slate-400">{hint}</p> : null}
    </Card>
  );
}
